import { gql } from "@apollo/client";

export const GET_BLOOMREACH_SEARCH_BY_KEYWORD_QUERY = gql`
  query BloomreachSearchByKeyword(
    $q: String!
    $rows: Int!
    $start: Int!
    $fq: [ProductFilterQuery]
    $sort: String
    $efq: EntityFilterQuery
    $locale: String!
    $brUid2: String
    $brRefUrl: String
  ) {
    bloomreachSearchByKeyword(
      q: $q
      rows: $rows
      start: $start
      fq: $fq
      sort: $sort
      efq: $efq
      locale: $locale
      _br_uid_2: $brUid2
      ref_url: $brRefUrl
    ) {
      response {
        numFound
        start
        docs {
          description
          title
          url
          brand
          pid
          thumb_image
          colorCount
          price
          sale_price
          sale_price_range
          pricePrevious
          salesChannel
          masterSkuId
          comingSoon
          variants {
            colorCode
            skuid
            sku_price
            sku_color
            sku_sale_price
            pricePrevious
            productImages {
              url
            }
          }
          sustainability
          clickAndCollect
          clickAndCollectExclusive
          pricePerUnit
          measureOfPrice
          uomOfPrice
          sku_color
          categoryPathsDisplayable
          collectionName
        }
      }
      facet_counts {
        facet_fields {
          ... on FacetCountsFacetFieldsCategoryFacet {
            key
            value {
              count
              crumb
              cat_name
              parent
              cat_id
              tree_path
            }
          }
          ... on FacetCountsFacetFieldsAttributeFacet {
            key
            value {
              count
              name
            }
          }
        }
        facet_ranges {
          key
          value {
            count
            start
            end
          }
        }
      }
      category_map {
        key
        value
      }
      keywordRedirect {
        url
      }
    }
  }
`;
